export default __webpack_public_path__ + "static/media/minus.41e7fe8f.svg";